import React from 'react'
import Product from './Product';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import './Slideproduct.css';
import { Navigation, Autoplay } from 'swiper/modules';


function Slideproduct({data, title}) {
  
  
  return (
    <div className='Slide_productes slide'>
        <div className="Container">
            <div className="top_slide">
                <h2>{title} </h2>
                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nihil alias, corrupti culpa cum et maiores veritatis in nemo, odit laboriosam voluptas totam quod, commodi quas dolores. Officia neque distinctio non.</p>
            </div>

           <Swiper 
           loop={true}
           autoplay={{
           delay: 2500,
           disableOnInteraction: false,}}
           slidesPerView={4}
           navigation={true}
           modules={[Navigation, Autoplay]}
           className="mySwiper">

            
               {data.map((item) => {
                return(
                 <SwiperSlide> <Product item={item} /> </SwiperSlide>

                )
               })}
              
         
        
       
      </Swiper>
        </div>
    </div>
  )
}

export default Slideproduct